import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Order, PagedOrders, CalculatedOrderRoute } from '../models/orders.models';
import { environment } from 'src/environments/environment';
import { CitiesService } from '../../cities/services/cities.service';
import { map } from 'rxjs/operators';
import { CashStatus } from '../models/orders.models';
@Injectable({
  providedIn: 'root'
})
export class OrdersServerService {
  private url = `${environment.apiUrl}/services`;

  constructor(private http: HttpClient, private citiesService: CitiesService) {}

  getOrders(filters: any): Observable<PagedOrders> {
    this.getVehicleTypes().subscribe((vehicleTypes) => {
      console.log('Vehicle Types:', vehicleTypes);
    });
    const formattedFilters = { ...filters };
    if (formattedFilters.date) {
      formattedFilters.date = new Date(formattedFilters.date).toISOString().split('T')[0];
    }
    if (formattedFilters.from) {
      formattedFilters.from = new Date(formattedFilters.from).toISOString().split('T')[0];
    }
    if (formattedFilters.to) {
      formattedFilters.to = new Date(formattedFilters.to).toISOString().split('T')[0];
    }

      const cleanedFilters = Object.keys(formattedFilters)
      .filter((key) => formattedFilters[key] !== null && formattedFilters[key] !== undefined && formattedFilters[key] !== '')
      .reduce((obj, key) => {
        obj[key] = formattedFilters[key];
        return obj;
      }, {});
  

    const queryString = Object.keys(cleanedFilters)
      .map((key) => `${key}=${encodeURIComponent(cleanedFilters[key])}`)
      .join('&');
  
    const finalQueryString = queryString || `filter=all&all_times=True`;
    console.log('Query String:', finalQueryString);

    return this.http.get<PagedOrders>(`${this.url}?filter=all&all_times=True&${finalQueryString}`);
  }

  getManualOrders(page: number, limit: number, query?: string, from?: Date, to?: Date): Observable<PagedOrders> {
    let queryString = `filter=manual&page=${page}&limit=${limit}`;
    if (query) {
      queryString += `&search=${query}`;
    }
    if (from) {
      queryString += `&from=${from.toISOString().split('T')[0]}`;
    }
    if (to) {
      queryString += `&to=${to.toISOString().split('T')[0]}`;
    }
    return this.http.get<PagedOrders>(`${this.url}?${queryString}`);
  }

  getPendingOrders(page: number, limit: number, query?: string): Observable<PagedOrders> {
    let queryString = `filter=pending&page=${page}&limit=${limit}`;
    if (query) {
      queryString += `&search=${query}`;
    }
    return this.http.get<PagedOrders>(`${this.url}?${queryString}`);
  }

  getInProgressOrders(page: number, limit: number, query?: string): Observable<PagedOrders> {
    let queryString = `filter=in_progress&page=${page}&limit=${limit}`;
    if (query) {
      queryString += `&search=${query}`;
    }
    return this.http.get<PagedOrders>(`${this.url}?${queryString}`);
  }

  getFinishedOrders(page: number, limit: number, query?: string): Observable<PagedOrders> {
    let queryString = `filter=finished&page=${page}&limit=${limit}`;
    if (query) {
      queryString += `&search=${query}`;
    }
    return this.http.get<PagedOrders>(`${this.url}?${queryString}`);
  }

  getPendingOrdersWithCashToCollet(page: number, limit: number, query?: string): Observable<PagedOrders> {
    const now = new Date();
    const threeDaysAgo = new Date(now);
    threeDaysAgo.setDate(now.getDate() - 2); // Incluye hoy, ayer y anteayer

    const from = threeDaysAgo.toISOString().split('T')[0];
    const to = now.toISOString().split('T')[0];

    let queryString = `filter=finished&limit=5000&from=${from}&to=${to}`;
    if (query) {
      queryString += `&search=${query}`;
    }

  return this.http.get<PagedOrders>(`${this.url}?${queryString}`).pipe(
    map((pagedOrders: PagedOrders) => {
      const filtered = pagedOrders.items.filter(order =>
        order.cash_status !== 0 && order.cash_status_confirmed !== true
      );
      return {
        ...pagedOrders,
        items: filtered,
        results: filtered
      };
    })
  );
  }

  getOrderByRiderId(rider_id: number, page: number, limit: number, from?: Date, to?: Date): Observable<PagedOrders> {
    let queryString = `filter=all&all_times=True&page=${page}&limit=${limit}&rider_id=${rider_id}`;
    if (from) {
      queryString += `&from=${from.toISOString().split('T')[0]}`;
    }
    if (to) {
      queryString += `&to=${to.toISOString().split('T')[0]}`;
    }
    return this.http.get<PagedOrders>(`${this.url}?${queryString}`);
  }

  getOrderById(id: number): Observable<PagedOrders> {
    const url = `${this.url}?service_id=${id}`;
    return this.http.get<PagedOrders>(url);
  }

  createOrder(order: Order): Observable<Order> {
    return this.http.post<Order>(this.url, order);
  }

  createManualOrder(order: Order): Observable<Order> {
    const selectedCity = this.citiesService.getUserSelectedCityId();
    const orderWithCity = { ...order, ops_city_id: selectedCity };
    return this.http.post<Order>(`${environment.apiUrl}/manualServiceCreate`, orderWithCity);
  }

  editOrder(id: number, order: Order): Observable<Order> {
    const url = `${this.url}/${id}`;
    return this.http.put<Order>(url, order);
  }

  searchOrders(page: number, limit: number, query: string): Observable<PagedOrders> {
    return this.http.get<PagedOrders>(`${this.url}?filter=all&page=${page}&limit=${limit}&search=${query}`);
  }

  assignOrderToRider(service_id: number, rider_id: number): Observable<Order> {
    const url = `${environment.apiUrl}/service/assign`;
    const body = { service_id, rider_id };
    return this.http.post<Order>(url, body);
  }

  calculateRoute(order: Order): Observable<CalculatedOrderRoute> {
    console.log('Calculating route for order:', order);
    const url = `${environment.apiUrl}/service_route/calculate`;
    return this.http.post<CalculatedOrderRoute>(url, order);
  }

  cancelOrder(id: number): Observable<Order> {
    const url = `${this.url}/${id}?delete_multiple_service_requests=True&delete_in_progress_service=True`;
    return this.http.delete<Order>(url, {});
  }

  reassingOrder(service_id: number, rider_id: number): Observable<Order> {
    const url = `${environment.apiUrl}/service/unassign`;
    const body = { service_id, rider_id };
    return this.http.post<Order>(url, body);
  }

  confirmCashDelivered(service_id: number, confirmed: string): Observable<Order> {
    console.log('CONFIRMANDO ENTREGA DE EFECTIVO', service_id, confirmed);
    const url = `${environment.apiUrl}/confirmCashDelivered/${service_id}`;
    const body = { confirmed };
    return this.http.post<Order>(url, body);
  }

  getVehicleTypes(): Observable<any[]> {
    console.log('getVehicleTypes')
    return this.http.get<any[]>(`${environment.apiUrl}/vehicleTypes`);
  }

  getFilteredOrders(filters: any): Observable<PagedOrders> {
    // Formatear las fechas en el formato YYYY-MM-DD
    const formattedFilters = { ...filters };
    if (formattedFilters.date) {
      formattedFilters.date = new Date(formattedFilters.date).toISOString().split('T')[0];
    }
    if (formattedFilters.from) {
      formattedFilters.from = new Date(formattedFilters.from).toISOString().split('T')[0];
    }
    if (formattedFilters.to) {
      formattedFilters.to = new Date(formattedFilters.to).toISOString().split('T')[0];
    }
  
    // Limpiar los filtros eliminando los valores null, undefined o vacíos
    const cleanedFilters = Object.keys(formattedFilters)
      .filter((key) => formattedFilters[key] !== null && formattedFilters[key] !== undefined && formattedFilters[key] !== '')
      .reduce((obj, key) => {
        obj[key] = formattedFilters[key];
        return obj;
      }, {});
  
    // Construir el query string
    const queryString = Object.keys(cleanedFilters)
      .map((key) => `${key}=${encodeURIComponent(cleanedFilters[key])}`)
      .join('&');
  
    const finalQueryString = queryString || `filter=all&all_times=True`;
  
    console.log('Query String:', finalQueryString); // Para depuración
    return this.http.get<PagedOrders>(`${this.url}?filter=all&limit=10000&${finalQueryString}`);
  }

    getManualOrderByRiderId(rider_id: number, page: number, limit: number, from?: Date, to?: Date): Observable<PagedOrders> {
    let queryString = `filter=manual&page=${page}&limit=${limit}&rider_id=${rider_id}`;
    if (from) {
      queryString += `&from=${from.toISOString().split('T')[0]}`;
    }
    if (to) {
      queryString += `&to=${to.toISOString().split('T')[0]}`;
    }
    return this.http.get<PagedOrders>(`${this.url}?${queryString}`);
  }

  getExportedData(from: Date, to: Date): Observable<any> {
    if (!from || !to) {
      throw new Error("You must provide 'from' and 'to' as valid dates");
    }
    const fromStr = from.toISOString().split('T')[0];
    const toStr = to.toISOString().split('T')[0];
    
    return this.http.post<any>(
      `${environment.apiUrl}/services/export/${fromStr}/${toStr}`,
      {} 
    );
  }
}